(function () {
  'use strict';

  var gallery = null;
  var images = [];
  var currentIndex = 0;
  var touchStartX = null;
  var previousOverflow = '';

  function normalizeUrl(img) {
    return img.getAttribute('data-original') || img.currentSrc || img.src || '';
  }

  function collectImages(clicked) {
    var root = clicked.closest('.brator-product-img-tab-list');
    if (!root) {
      return [{ url: normalizeUrl(clicked), alt: clicked.alt || '', source: clicked }];
    }
    var candidates = root.querySelectorAll('.js-tabs__content .product__media img[data-action="zoom"]');
    var seen = {};
    var list = [];

    candidates.forEach(function (img) {
      var url = normalizeUrl(img);
      if (!url || seen[url]) return;
      seen[url] = true;
      list.push({
        url: url,
        alt: img.alt || '',
        source: img
      });
    });

    return list;
  }

  function ensureStyles() {
    if (document.getElementById('ppmx-zoom-gallery-styles')) return;
    var style = document.createElement('style');
    style.id = 'ppmx-zoom-gallery-styles';
    style.textContent = [
      '.ppmx-zoom-gallery{position:fixed;inset:0;z-index:2147483000;background:#fff;display:flex;align-items:center;justify-content:center;overscroll-behavior:contain;touch-action:pan-y}',
      '.ppmx-zoom-gallery__stage{position:relative;width:100%;height:100%;display:flex;align-items:center;justify-content:center;padding:56px 84px 48px;box-sizing:border-box}',
      '.ppmx-zoom-gallery__img{display:block;max-width:100%;max-height:100%;width:auto;height:auto;object-fit:contain;user-select:none;-webkit-user-drag:none}',
      '.ppmx-zoom-gallery__close,.ppmx-zoom-gallery__nav{position:absolute;border:0;background:rgba(0,0,0,.62);color:#fff;cursor:pointer;display:flex;align-items:center;justify-content:center;z-index:2;box-shadow:0 2px 8px rgba(0,0,0,.18)}',
      '.ppmx-zoom-gallery__close{top:16px;right:16px;width:44px;height:44px;border-radius:50%;font-size:30px;line-height:1}',
      '.ppmx-zoom-gallery__nav{top:50%;transform:translateY(-50%);width:48px;height:64px;border-radius:6px;font-size:38px;line-height:1}',
      '.ppmx-zoom-gallery__prev{left:18px}.ppmx-zoom-gallery__next{right:18px}',
      '.ppmx-zoom-gallery__counter{position:absolute;bottom:14px;left:50%;transform:translateX(-50%);background:rgba(0,0,0,.62);color:#fff;padding:6px 11px;border-radius:999px;font:600 13px/1.2 Arial,sans-serif;z-index:2}',
      '.ppmx-zoom-gallery button:focus-visible{outline:3px solid #3b82f6;outline-offset:3px}',
      '@media(max-width:749px){.ppmx-zoom-gallery__stage{padding:54px 48px 42px}.ppmx-zoom-gallery__nav{width:40px;height:56px;font-size:32px}.ppmx-zoom-gallery__prev{left:6px}.ppmx-zoom-gallery__next{right:6px}.ppmx-zoom-gallery__close{top:8px;right:8px;width:40px;height:40px;font-size:28px}}'
    ].join('');
    document.head.appendChild(style);
  }

  function render() {
    if (!gallery || !images.length) return;
    var image = gallery.querySelector('.ppmx-zoom-gallery__img');
    var counter = gallery.querySelector('.ppmx-zoom-gallery__counter');
    var prev = gallery.querySelector('.ppmx-zoom-gallery__prev');
    var next = gallery.querySelector('.ppmx-zoom-gallery__next');
    var item = images[currentIndex];

    image.src = item.url;
    image.alt = item.alt;
    counter.textContent = (currentIndex + 1) + ' / ' + images.length;

    var showNav = images.length > 1;
    prev.hidden = !showNav;
    next.hidden = !showNav;
    counter.hidden = !showNav;
  }

  function show(delta) {
    if (images.length < 2) return;
    currentIndex = (currentIndex + delta + images.length) % images.length;
    render();
  }

  function closeGallery() {
    if (!gallery) return;
    document.removeEventListener('keydown', onKeydown);
    document.body.style.overflow = previousOverflow;
    gallery.remove();
    gallery = null;
    images = [];
    touchStartX = null;
  }

  function onKeydown(event) {
    if (!gallery) return;
    if (event.key === 'Escape') closeGallery();
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      show(-1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      show(1);
    }
  }

  function openGallery(clicked) {
    images = collectImages(clicked);
    if (!images.length) {
      images = [{ url: normalizeUrl(clicked), alt: clicked.alt || '', source: clicked }];
    }

    var clickedUrl = normalizeUrl(clicked);
    var foundIndex = images.findIndex(function (item) { return item.url === clickedUrl; });
    currentIndex = foundIndex >= 0 ? foundIndex : 0;

    ensureStyles();
    gallery = document.createElement('div');
    gallery.className = 'ppmx-zoom-gallery';
    gallery.setAttribute('role', 'dialog');
    gallery.setAttribute('aria-modal', 'true');
    gallery.setAttribute('aria-label', 'Product image gallery');
    gallery.innerHTML = '<div class="ppmx-zoom-gallery__stage">' +
      '<button type="button" class="ppmx-zoom-gallery__close" aria-label="Close image gallery">&times;</button>' +
      '<button type="button" class="ppmx-zoom-gallery__nav ppmx-zoom-gallery__prev" aria-label="Previous image">&#8249;</button>' +
      '<img class="ppmx-zoom-gallery__img" alt="">' +
      '<button type="button" class="ppmx-zoom-gallery__nav ppmx-zoom-gallery__next" aria-label="Next image">&#8250;</button>' +
      '<div class="ppmx-zoom-gallery__counter" aria-live="polite"></div>' +
      '</div>';

    previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    document.body.appendChild(gallery);

    gallery.querySelector('.ppmx-zoom-gallery__close').addEventListener('click', closeGallery);
    gallery.querySelector('.ppmx-zoom-gallery__prev').addEventListener('click', function () { show(-1); });
    gallery.querySelector('.ppmx-zoom-gallery__next').addEventListener('click', function () { show(1); });
    gallery.addEventListener('click', function (event) {
      if (event.target === gallery || event.target.classList.contains('ppmx-zoom-gallery__stage')) closeGallery();
    });
    gallery.addEventListener('touchstart', function (event) {
      if (event.touches && event.touches.length === 1) touchStartX = event.touches[0].clientX;
    }, { passive: true });
    gallery.addEventListener('touchend', function (event) {
      if (touchStartX === null || !event.changedTouches || !event.changedTouches.length) return;
      var diff = event.changedTouches[0].clientX - touchStartX;
      touchStartX = null;
      if (Math.abs(diff) < 40) return;
      show(diff > 0 ? -1 : 1);
    }, { passive: true });

    document.addEventListener('keydown', onKeydown);
    render();
    gallery.querySelector('.ppmx-zoom-gallery__close').focus();
  }

  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || target.tagName !== 'IMG' || target.getAttribute('data-action') !== 'zoom') return;
    if (event.metaKey || event.ctrlKey) {
      window.open(normalizeUrl(target), '_blank');
      return;
    }

    event.preventDefault();
    event.stopImmediatePropagation();
    openGallery(target);
  }, true);
}());
